<template>
  <svg class="valentine-icon" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <text class="cls-11" transform="translate(1.22 3.3)">
      <tspan x="0" y="0">П</tspan>
      <tspan class="cls-7" x="1.56" y="0">Р</tspan>
      <tspan x="2.97" y="0">ОМО</tspan>
      <tspan class="cls-2" x="8.71" y="0">К</tspan>
      <tspan class="cls-5" x="10.04" y="0">О</tspan>
      <tspan x="11.87" y="0">Д</tspan>
    </text>
    <text class="cls-3" transform="translate(1.24 14.45)">
      <tspan x="0" y="0">в</tspan>
      <tspan class="cls-8" x="2.29" y="0">к</tspan>
      <tspan class="cls-9" x="3.72" y="0">абін</tspan>
      <tspan class="cls-6" x="9.75" y="0">е</tspan>
      <tspan x="11.45" y="0">ті</tspan>
    </text>
    <rect class="cls-4" x="1.01" y="5.27" width="10.26" height="6.11" rx=".39" ry=".39" />
    <rect class="cls-4" x="11.26" y="5.28" width="3.73" height="6.11" rx=".39" ry=".39" />
    <circle class="cls-1" cx="11.27" cy="6.19" r=".32" />
    <circle class="cls-1" cx="11.27" cy="7.24" r=".32" />
    <circle class="cls-1" cx="11.27" cy="8.3" r=".32" />
    <circle class="cls-1" cx="11.27" cy="9.35" r=".32" />
    <circle class="cls-1" cx="11.27" cy="10.4" r=".32" />
    <path class="cls-10"
          d="M9.16,4.66c.91.91.91,2.39,0,3.3h0s-2.6,2.6-2.6,2.6c-.39.39-1.02.39-1.4,0,0,0,0,0,0,0l-2.6-2.6c-.91-.91-.91-2.39,0-3.3,0,0,.01-.01.02-.02.9-.88,2.37-.87,3.28.02.91-.91,2.39-.91,3.3,0h0Z" />
    <path class="cls-4"
          d="M5.16,7c-.14,0-.25-.11-.25-.25,0-.14.11-.25.25-.25.14,0,.25.11.25.25,0,.14-.11.25-.25.25ZM6.54,7.72c-.14,0-.25.11-.25.25s.11.25.25.25.25-.11.25-.25h0c0-.14-.11-.25-.25-.25ZM7.78,7.35c0,1.06-.86,1.92-1.92,1.92-1.06,0-1.92-.86-1.92-1.92s.86-1.92,1.92-1.92h0c1.06,0,1.92.86,1.92,1.92h0ZM5.16,7.28c.29,0,.53-.24.53-.53,0-.29-.24-.53-.53-.53-.29,0-.53.24-.53.53,0,.29.24.53.53.53h0ZM6.81,6.6c.05-.05.05-.14,0-.19-.05-.05-.14-.05-.19,0l-1.7,1.7c-.05.05-.05.14,0,.19.05.05.14.05.19,0,0,0,0,0,0,0l1.7-1.7ZM7.06,7.97c0-.29-.24-.53-.53-.53s-.53.24-.53.53.24.53.53.53h0c.29,0,.53-.24.53-.53h0Z" />
  </svg>
</template>

<script>
export default {
  name: 'ValentineIcon',
}
</script>

<style>
.valentine-icon {
  width: 40px;
  height: 40px;

  .cls-1 {
    fill: #fff;
  }

  .cls-2 {
    letter-spacing: -.06em;
  }

  .cls-3 {
    font-family: Gilroy-SemiBold, Gilroy;
    font-size: 3.02px;
    font-weight: 600;
  }

  .cls-3, .cls-4 {
    fill: #edabcd;
  }

  .cls-5 {
    letter-spacing: -.03em;
  }

  .cls-6 {
    letter-spacing: -.02em;
  }

  .cls-7 {
    letter-spacing: 0em;
  }

  .cls-8 {
    letter-spacing: -.04em;
  }

  .cls-9 {
    letter-spacing: 0em;
  }

  .cls-10, .cls-11 {
    fill: #b21b55;
  }

  .cls-11 {
    font-family: Gilroy-Bold, Gilroy;
    font-size: 2.4px;
    font-weight: 700;
  }
}
</style>
